import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Configuration } from 'src/app/app.constants';
import { ValidatedViewModel } from '../../shared/viewModels/validatedViewModel';
import { EmployeeUserGroupViewModel } from '../viewModels/userGroups/employeeUserGroupViewModel';
import { UserGroupViewModel } from '../viewModels/userGroups/userGroupViewModel';

@Injectable({
  providedIn: 'root',
})
export class UserGroupService {
  private baseUrl: string;
  constructor(private http: HttpClient, private configuration: Configuration) {
    this.baseUrl = this.configuration.buildEndpoint('UserGroup/');
  }

  add(model: UserGroupViewModel): Observable<ValidatedViewModel> {
    return this.http.post<ValidatedViewModel>(`${this.baseUrl}Add`, model);
  }

  list(): Observable<UserGroupViewModel[]> {
    return this.http.get<UserGroupViewModel[]>(`${this.baseUrl}List`);
  }

  listByEmployeeId(employeeId: number): Observable<UserGroupViewModel[]> {
    return this.http.get<UserGroupViewModel[]>(`${this.baseUrl}ListByEmployee/${employeeId}`);
  }

  update(model: UserGroupViewModel): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}Update`, model);
  }

  bulkDelete(ids: number[]): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}Delete`, ids);
  }

  addUserToGroups(employeeId: number, groupIds: number[]): Observable<EmployeeUserGroupViewModel[]> {
    return this.http.post<EmployeeUserGroupViewModel[]>(`${this.baseUrl}AddUserToGroups/${employeeId}`, groupIds);
  }

  addUsersToGroup(groupId: number, employeeIds: number[]): Observable<EmployeeUserGroupViewModel[]> {
    return this.http.post<EmployeeUserGroupViewModel[]>(`${this.baseUrl}AddUsersToGroup/${groupId}`, employeeIds);
  }

  deleteEmployeeUserGroups(uesrGroupViewModels: EmployeeUserGroupViewModel[]): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}DeleteEmployeeUserGroups`, uesrGroupViewModels);
  }
}
